import { render, staticRenderFns } from "./blogDetail.vue?vue&type=template&id=1abae1f0&scoped=true&"
import script from "./blogDetail.vue?vue&type=script&lang=js&"
export * from "./blogDetail.vue?vue&type=script&lang=js&"
import style0 from "./blogDetail.vue?vue&type=style&index=0&id=1abae1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abae1f0",
  null
  
)

export default component.exports